import type { TBboxStyle } from '@vlabs/monokit/shared/ui/canvas/bbox-renderer/types';

export const DEFAULT_BBOX_STYLES: TBboxStyle = {
  base: {
    stroke: 'rgba(34, 195, 75, 1)',
    strokeWidth: 1,
    fill: 'rgba(0,0,0,0)',
    fillEnabled: true,
  },
  hover: {
    stroke: 'rgba(0, 153, 39, 1)',
    strokeWidth: 2,
    fill: 'rgba(0,0,0,0)',
    fillEnabled: true,
  },
  selected: {
    stroke: 'rgba(0, 153, 39, 1)',
    strokeWidth: 2,
    fill: 'rgba(173, 235, 189, 0.5)',
    fillEnabled: true,
  },
};
